import { LocalizationService } from "../../ShellCommon/localization/localization";
export class MissingConsentController {
  // @ngInject
  constructor(private sdLocalizationService: LocalizationService) {}
}
